const identifyingGAPath = 'identifyingGA.'
const complementPathway = 'complementPathway.'

const pathwayTrans = {
    DISCOVER_DESCRIPTION: complementPathway + 'discoverDescription',
    PIVOTAL_PLAYER: complementPathway + 'pivotalPlayer',
    PIVOTAL_DESCRIPTION: complementPathway + 'pivotalDescription',
    IMAGE_CAPTION: complementPathway + 'imageCaption',
    WATCH_AND_DISCOVER: identifyingGAPath + 'watchAndDiscover',
}

export default pathwayTrans